export let LayerTreeNodeType;(function(e){e["LAYER"]="LAYER";e["LAYER_GROUP"]="LAYER_GROUP"})(LayerTreeNodeType||(LayerTreeNodeType={}));